// extracted by mini-css-extract-plugin
export default {"imageContainer":"Cea-z","summaryPar":"Dea-z","ratingCategories":"Eea-z","reviewerInfo":"Fea-z","reviewTypes":"Gea-z","expanded":"Hea-z"};